<div class="ui-g ui-fluid clear-ui">
    <div class="ui-g-12">
        <h1 class="card__title--h1 color--white layout-page-title">Report Definitions</h1>
        <button style="font-size: 20px; margin-left: 10px" pButton (click)="addClick()" pTooltip="Create new" tooltipPosition="top" icon="ui-button-icon-left ui-clickable pi pi-plus" class="ui-button ui-widget ui-state-default ui-corner-all ui-button-icon-only"></button>
        <button style="font-size: 20px" pButton (click)="executeClick()" pTooltip="Process Reports" tooltipPosition="top" icon="ui-button-icon-left ui-clickable pi pi-cog" class="ui-button ui-widget ui-state-default ui-corner-all ui-button-icon-only"></button>
    </div>
    <div class="ui-g-12 p-grid">
        <report-card class="p-col-12 p-sm-6 p-md-4 p-lg-3" *ngFor="let item of objects" [Report]="item"></report-card>
    </div>
    <p-dialog class="ui-fluid" header="Process reports" [(visible)]="displayExecutor" *ngIf="displayExecutor"
        [style]="{width: '40%'}" appendTo="body">
        <div *ngIf="!executingProcessReports" class="ui-g form-group">
            <!-- 
            <div class="p-g-12">
                <div class="p-float-label">
                    <input pInputText [(ngModel)]="this.companyCode">
                    <label>Company code</label>
                    
                </div>
            </div>
            -->
            <div class="ui-g-12">
                <div class="p-float-label">
                    <p-dropdown class="dropdown-reportDefinitions" [(ngModel)]="this.company.companyCode" [options]="this.companies" optionLabel="name" [autoDisplayFirst]=false
                dataKey="id" (onChange)="onChange($event)"></p-dropdown>
                <label>Company code</label>
                </div>
            </div>
            <div class="ui-g-12">
                <div class="p-float-label ">
                    <p-dropdown class="dropdown-reportDefinitions" [(ngModel)]="this.reportCode" [options]="this.objects" optionLabel="Name" [autoDisplayFirst]=false
                dataKey="id" (onChange)="onChange($event)"></p-dropdown>
                <label>Report code</label>
                </div>
            </div>
            <!-- 
            <div class="ui-g-12">
                <div class="p-float-label">
                    <input pInputText [(ngModel)]="this.reportCode">
                    <label>Report code</label>
                </div>
            </div>
             -->
        </div>
        <div *ngIf="!executingProcessReports" class="ui-g-12">
            <button label="Execute" pButton icon="pi pi-check" (click)="executeProcessReports()"
                style="margin-right: 0.5em"></button>
            <button label="Cancel" pButton icon="pi pi-times"
                (click)="displayExecutor=false;"></button>
        </div>
        <p *ngIf="executingProcessReports">{{this.processReportsStatus}}</p>
        <button *ngIf="executedProcessReports" type="button" label="OK" pButton icon="pi pi-check"
            (click)="this.executingProcessReports = false; this.executedProcessReports = false;"></button>
    </p-dialog>
</div>
